import React, { useContext } from 'react';
import Head from '../Head';
import { getGlobalClassnamesForContext } from '@wix/da-react-context/pkg/helpers';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { FlagContext } from '@wix/da-react-context/pkg/flags/FlagContext';
import Flag from '@wix/da-react-context/pkg/flags/Flag/Flag';
import { useSelector } from 'react-redux';
import { getEnv } from '../Environment/redux/selectors';
import noop from 'lodash/noop';
const Document = ({ children, themeSelector, themeSkinSelector })=>{
    var _session_device;
    const session = useContext(SessionContext);
    const flags = useContext(FlagContext);
    const env = useSelector(getEnv);
    const theme = useSelector(themeSelector !== null && themeSelector !== void 0 ? themeSelector : noop);
    const themeSkin = useSelector(themeSkinSelector !== null && themeSkinSelector !== void 0 ? themeSkinSelector : noop);
    return /*#__PURE__*/ React.createElement("html", {
        lang: "en",
        "data-appinfo": env.appInfo
    }, /*#__PURE__*/ React.createElement(Head, null), /*#__PURE__*/ React.createElement("body", {
        className: getGlobalClassnamesForContext({
            flags,
            isLoggedIn: session.isLoggedIn,
            isMobile: (_session_device = session.device) === null || _session_device === void 0 ? void 0 : _session_device.isMobile,
            theme: theme !== null && theme !== void 0 ? theme : session.theme,
            themeSkin: themeSkin !== null && themeSkin !== void 0 ? themeSkin : session.themeSkin
        })
    }, /*#__PURE__*/ React.createElement(Flag, {
        condition: "strictmode",
        render: ()=>/*#__PURE__*/ React.createElement(React.StrictMode, null, children),
        fallbackRender: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, children)
    })));
};
Document.displayName = 'Document';
export default Document;

//# sourceMappingURL=Document.js.map